// extracted by mini-css-extract-plugin
module.exports = {"surveysHistoryContainer":"surveysHistoryView_surveysHistoryContainer__13oNM","search":"surveysHistoryView_search__TX_5M","empty":"surveysHistoryView_empty__OJy_A"};